import React from "react";
import styles from "./styles.module.scss";
import Tooltip from "../Tooltip";
import { cn } from "@utils/utils";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";

interface FeatureItemProps {
  title: string;
  subtitle?: string;
  included?: boolean;
  tooltip?: string;
  className?: string;
}

export const FeatureItem: React.FC<FeatureItemProps> = ({
  title,
  subtitle,
  included = true,
  tooltip,
  className,
}) => {
  if(subtitle === 'Not Applicable') return null;
  return (
    <div className={cn(styles.feature, className)}>
      <Image
        src={
          included
            ? `${assetLoader()}/icons/Check_tick_correct.svg`
            : `${assetLoader()}/icons/CloseCross.svg`
        }
        alt={title}
        width={20}
        height={20}
      />
      <div className={styles.feature__content}>
        <div className={styles.feature__title}>
          {title}
          {tooltip && (
            <Tooltip content={tooltip}>
              <Image
                src={`${assetLoader()}/icons/info.svg`}
                alt="Info"
                width={14}
                height={14}
                className={styles.feature__info}
              />
            </Tooltip>
          )}
        </div>
        {subtitle && <p className={styles.feature__subtitle}>{subtitle}</p>}
      </div>
    </div>
  );
};
